var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.33301C6.36819 1.33301 6.66699 1.63181 6.66699 2C6.66699 2.36819 6.36819 2.66699 6 2.66699H3C2.81591 2.66699 2.66699 2.81591 2.66699 3V13C2.66699 13.1841 2.8159 13.333 3 13.333H13C13.1841 13.333 13.333 13.1841 13.333 13V9.8252C13.333 9.45701 13.6318 9.1582 14 9.1582C14.3682 9.1582 14.667 9.45701 14.667 9.8252V13C14.667 13.9205 13.9205 14.667 13 14.667H3C2.07953 14.667 1.33301 13.9205 1.33301 13V3C1.33301 2.07953 2.07953 1.33301 3 1.33301H6ZM14.0684 1.33691C14.4044 1.37115 14.667 1.65489 14.667 2V6.66699C14.6668 7.03503 14.3681 7.33301 14 7.33301C13.6319 7.33301 13.3332 7.03503 13.333 6.66699V3.61035L9.07129 7.87207C8.81108 8.13188 8.38918 8.13178 8.12891 7.87207C7.8686 7.61176 7.86869 7.18907 8.12891 6.92871L12.3906 2.66699H9.33301C8.96497 2.66682 8.66699 2.36808 8.66699 2C8.66699 1.63192 8.96497 1.33318 9.33301 1.33301H14L14.0684 1.33691Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3fa0fca2ee08a5f0523d9bf5c68a41df.svg";
export { ForwardRef as ReactComponent };